'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Anchor = function (_Component) {
    _inherits(Anchor, _Component);

    function Anchor() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Anchor);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Anchor.__proto__ || Object.getPrototypeOf(Anchor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            visuallyhidden: true
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Anchor, [{
        key: 'onFocus',
        value: function onFocus() {
            this.setState({ visuallyhidden: false });
        }
    }, {
        key: 'onBlur',
        value: function onBlur() {
            this.setState({ visuallyhidden: true });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var classes = (0, _classnames3.default)('noprint', _defineProperty({}, this.props.theme.visuallyhidden, this.state.visuallyhidden));

            return _react2.default.createElement(
                'a',
                {
                    href: this.props.href,
                    className: classes,
                    onFocus: function onFocus() {
                        return _this2.onFocus();
                    },
                    onBlur: function onBlur() {
                        return _this2.onBlur();
                    }
                },
                this.props.anchorText
            );
        }
    }]);

    return Anchor;
}(_react.Component);

Anchor.propTypes = {
    href: _propTypes2.default.string.isRequired,
    anchorText: _propTypes2.default.string.isRequired,
    theme: _propTypes2.default.object.isRequired };
exports.default = Anchor;
//# sourceMappingURL=Anchor.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-skip-to-content/lib/cjs/Anchor.js
 ** module id = 668
 ** module chunks = 1
 **/